module.exports = __webpack_public_path__ + "img/logo_login.388fbc50.png";